<template>
  <div class="hotelNumberRightInner">
    <dl>
      <dt>客室{{ roomIdx + 1 }}</dt>
      <dd>
        <p class="hotelNumberItem">
          <label>大人</label>
          <select v-model="adultNumber">
            <option v-for="idx in maxPersons" :key="idx" :value="idx">
              {{ idx }}名
            </option>
          </select>
        </p>
        <p class="hotelNumberItem">
          <label>子ども</label>
          <select v-model="childNumber">
            <option :key="0" :value="0">0名</option>
            <option v-for="idx in maxPersons" :key="idx" :value="idx">
              {{ idx }}名
            </option>
          </select>
        </p>
      </dd>
    </dl>

    <div v-show="childNumber > 0" class="childAge">
      <p>お子様の年齢を入力してください。</p>
      <ul class="childAgeList">
        <li
          v-for="(child, index) in childAgeList"
          v-show="index < childNumber"
          :key="`childAges_${index}`"
        >
          <label>{{ index + 1 }}人目</label>
          <select v-model="child.value">
            <option :value="0">0歳</option>
            <option
              v-for="age in maxChildAge"
              :key="`age_${index}_${age}`"
              :value="age"
            >
              {{ age }}歳
            </option>
          </select>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassengerInput',
  components: {},
  props: {
    roomIdx: {
      type: Number,
      required: true,
    },
    roomTraveller: {
      type: Object,
      default() {
        return {
          adultNumber: 1,
          childNumber: 0,
          childAges: [],
        }
      },
    },
    maxPersons: {
      type: Number,
      required: true,
    },
    maxChildAge: {
      type: Number,
      required: true,
    },
  },
  data() {
    const { adultNumber, childNumber, childAges } = this.roomTraveller
    const defauftChildAge = 0

    const initChildAges = []
    for (let i = 0; i < this.maxChildAge; i++) {
      initChildAges.push({ value: Number(childAges[i]) || defauftChildAge })
    }

    return {
      adultNumber: adultNumber,
      childNumber: childNumber,
      childAges: childAges,
      childAgeList: initChildAges,
    }
  },
  computed: {
    selectedChildAges() {
      const lst = []
      for (let i = 0; i < this.childNumber; i++) {
        lst.push(this.childAgeList[i].value)
      }
      return lst
    },
    selectedRoomCondition() {
      return {
        adultNumber: this.adultNumber,
        childNumber: this.childNumber,
        childAges: this.selectedChildAges,
      }
    },
  },
  watch: {
    selectedRoomCondition(condition) {
      this.$emit('change-room-traveller', { condition, roomIdx: this.roomIdx })
    },
  },
}
</script>
